<template>
  <a
    :style="buttonElStyles"
    :target="button.link.target?.value || '_blank'"
    :href="applicationUrl"
    class="apply-button"
    @click="$emit('emittedClick')"
  >
    <span class="apply-text">
      {{ button.text }}
    </span>
  </a>
</template>

<script>
import { buttonComputed } from "../mixins/button.js";

export default {
  name: "GlobalUIApplyButton",
  mixins: [buttonComputed],
  props: {
    button: {
      type: Object,
      default() {
        return {};
      },
    },
    applicationUrl: {
      type: String,
      default: "",
    },
  },
  emits: ["emittedClick"],
};
</script>

<style lang="scss" scoped>
.apply-button {
  --apply-button-padding-x: 30px;
  --apply-button-padding-y: 10px;
  --button-border-radius: 10px;

  cursor: pointer;

  position: relative;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 350px;
  min-width: 125px;
  height: 50px;
  padding-block: var(--apply-button-padding-y);
  padding-inline: var(--apply-button-padding-x);

  font-size: 15px;
  font-weight: var(--cr-button-font-weight);
  font-style: normal;
  line-height: 15px;
  text-decoration: none;
  overflow-wrap: anywhere;

  border: 1px solid rgb(0 0 0 / 3%);

  transition: opacity 200ms ease-in-out;

  @include font-family("button");

  @include mobile {
    width: 100%;
  }

  &:hover {
    opacity: 0.8;
  }
}
</style>
